(function () {
  if (window.__preorderScriptLoaded) return;
  window.__preorderScriptLoaded = true;

  function getMap(sectionId) {
    var dataEl = document.getElementById('PreorderData-' + sectionId);
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function applyState(sectionId) {
    var form = document.getElementById('ProductFormPreorder-' + sectionId);
    if (!form) return;

    var variantInput = form.querySelector('.product-variant-id');
    if (!variantInput) return;

    var map = getMap(sectionId);
    if (!map) return;

    var info = map[variantInput.value];
    var isPreorderVariant = !!(info && info.is);
    var buttonTextEl = document.getElementById('ProductSubmitButtonText-' + sectionId);
    var submitButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var dynamicCheckout = document.getElementById('DynamicCheckout-' + sectionId);
    var propertyInput = document.getElementById('PreorderProperty-' + sectionId);
    var notice = document.getElementById('PreorderNotice-' + sectionId);

    if (!buttonTextEl || !submitButton) return;

    var isDisabled = submitButton.hasAttribute('disabled');

    if (isPreorderVariant && !isDisabled) {
      if (buttonTextEl.textContent.trim() !== 'Preordenar') {
        buttonTextEl.textContent = 'Preordenar';
      }
      submitButton.classList.remove('button--secondary');
      submitButton.classList.add('button--primary');
      if (dynamicCheckout && dynamicCheckout.style.display !== 'none') {
        dynamicCheckout.style.display = 'none';
      }
      if (propertyInput) {
        propertyInput.name = 'properties[Producto Preordenado]';
        propertyInput.value = 'Se entrega en ' + info.dias + ' días hábiles';
        propertyInput.disabled = false;
      }
      if (notice) {
        var newNoticeText = 'Producto bajo pedido — entrega estimada en ' + info.dias + ' días hábiles';
        if (notice.textContent.trim() !== newNoticeText) notice.textContent = newNoticeText;
        if (notice.hidden) notice.hidden = false;
      }
    } else if (!isDisabled) {
      var defaultText = buttonTextEl.getAttribute('data-default-text');
      if (defaultText && buttonTextEl.textContent.trim() !== defaultText) {
        buttonTextEl.textContent = defaultText;
      }
      var dynamicCheckoutEnabled = submitButton.getAttribute('data-dynamic-checkout') === 'true';
      if (dynamicCheckoutEnabled) {
        submitButton.classList.add('button--secondary');
        submitButton.classList.remove('button--primary');
      } else {
        submitButton.classList.remove('button--secondary');
        submitButton.classList.add('button--primary');
      }
      if (dynamicCheckout && dynamicCheckout.style.display === 'none') {
        dynamicCheckout.style.display = '';
      }
      if (propertyInput) {
        propertyInput.name = '';
        propertyInput.value = '';
        propertyInput.disabled = true;
      }
      if (notice && !notice.hidden) {
        notice.hidden = true;
      }
    }
    // Si está disabled (agotado/no disponible), no tocamos nada: Dawn ya lo maneja.
  }

  function watch(sectionId) {
    var form = document.getElementById('ProductFormPreorder-' + sectionId);
    if (!form || form.dataset.preorderObserved) return;
    form.dataset.preorderObserved = 'true';

    applyState(sectionId);

    setInterval(function () {
      applyState(sectionId);
    }, 300);
  }

  function init() {
    document.querySelectorAll('[id^="PreorderData-"]').forEach(function (el) {
      watch(el.id.replace('PreorderData-', ''));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();